document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-mobile-menu-toggle]');
  const nav = document.querySelector('[data-site-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
  document.querySelectorAll('[data-product-thumbnail]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const target = document.querySelector('[data-main-product-image]');
      if (!target) return;
      const src = thumb.getAttribute('data-large-src');
      const alt = thumb.getAttribute('alt') || '';
      if (src) {
        target.setAttribute('src', src);
        target.setAttribute('alt', alt);
      }
    });
  });
});
